import React from 'react';
import { MOBILE_APP_KICKER } from './appBranding';
import { BrandMark } from './LglMark';
import {
  FONT_OPTIONS,
  THEME_OPTIONS,
  TYPE_SIZE_OPTIONS,
  usePhoneTheme,
} from './theme';

const ChoiceRow = ({ legend, value, options, onChange }) => (
  <fieldset className="lgl-m-settings-block">
    <legend>{legend}</legend>
    <div className="lgl-m-chips" role="radiogroup" aria-label={legend}>
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          role="radio"
          aria-checked={value === option.id}
          className={`lgl-m-chip${value === option.id ? ' is-on' : ''}`}
          onClick={() => onChange(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  </fieldset>
);

export const SettingsScreen = ({ onBack }) => {
  const {
    preference,
    typeSize,
    font,
    setThemePreference,
    setTypeSize,
    setFont,
  } = usePhoneTheme();

  return (
    <>
      <header className="lgl-m-top">
        <div className="lgl-m-navrow">
          <button type="button" className="lgl-m-back" onClick={onBack} aria-label="Back">←</button>
          <div>
            <p className="lgl-m-kicker">{MOBILE_APP_KICKER}</p>
            <h1 className="lgl-m-title">Preferences</h1>
          </div>
          <BrandMark />
        </div>
        <p className="lgl-m-sub">Light, cream, or dark. Text size and font for this phone.</p>
      </header>
      <div className="lgl-m-body lgl-m-settings">
        <ChoiceRow
          legend="Theme"
          value={preference}
          options={THEME_OPTIONS}
          onChange={setThemePreference}
        />
        <ChoiceRow
          legend="Text size"
          value={typeSize}
          options={TYPE_SIZE_OPTIONS}
          onChange={setTypeSize}
        />
        <ChoiceRow
          legend="Font"
          value={font}
          options={FONT_OPTIONS}
          onChange={setFont}
        />
      </div>
    </>
  );
};

export default SettingsScreen;
